import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import RelatedBlogs from '../components/BlogComponents/RelatedBlogs';
import BlogDetailedHeader from '../components/BlogComponents/BlogDetailedHeader';
import BlogWidgetsContainer from '../components/BlogComponents/BlogWidgetsContainer';
import { fetchAllBlogPosts } from '../Data/BlogPost';
import CallToAction from '../components/Misc/CallToAction';

function BlogDetailed() {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlogData = async () => {
            try {
                setLoading(true);
                const posts = await fetchAllBlogPosts();
                
                if (!posts || posts.length === 0) {
                    setError('No blog posts found');
                    setLoading(false);
                    return;
                }

                // Find the blog by slug
                const foundBlog = posts.find(b => 
                    b.title && b.slug === slug
                );

                if (!foundBlog) {
                    setError('Blog post not found');
                    setLoading(false);
                    return;
                }

                setBlog(foundBlog);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching blog data:', err);
                setError('Failed to load blog post');
                setLoading(false);
            }
        };

        fetchBlogData();
    }, [slug]);

    if (loading) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center py-5">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading blog post...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error || !blog) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center py-5">
                        <h2>Error</h2>
                        <p>{error || 'Blog post not found'}</p>
                        <a href="/activities" className="btn btn-primary">Back to Activities</a>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <BlogDetailedHeader
                heading={blog.title}
                author={blog.author}
                category={blog.category}
                date={blog.date}
                authorImage={blog.image}
                thumbnail={blog.image}
            />

            <div className="container sidebar-page blog-single-page">
                <div className="row">
                    {/* first column - start */}
                    <div className="col-lg-8">
                        <div className="blog-single-page-wrapper blog-single-page-wrapper-right">
                            <div className="paragraph dark-1">
                                <p>{blog.content || blog.description}</p>
                            </div>
                        </div>
                    </div>
                    {/* first column - end */}
                    {/* second column - start */}
                    <div className="col-lg-4 sidebar-column">
                        <div className="sidebar-column-wrapper">
                            <BlogWidgetsContainer/>
                        </div>
                    </div>
                    {/* second column - end */}
                </div>
            </div>

            <RelatedBlogs />
            <CallToAction 
                wrapperClass='bg-main'
                heading={
                    <>
                        Love to join us? 
                        <br />
                        Volunteer with us now
                    </>
                }
                buttonText="Volunteer Now"
                buttonLink="/get-involved"
                buttonType="2"
                artwork={null}
            />
            <CallToAction 
                wrapperClass='projects-footer bg-black'
                headingClass='light-1'
                heading={
                    <>Need Support? Reach out today.</>
                }
                buttonText="Get Support"
                buttonLink="/contact"
                buttonType="1"
            />
        </>
    );
}

export default BlogDetailed;
